import React from 'react'
import classnames from 'classnames'

const TeamLink = ({
  team = {},
  isWebView = false
}) => {
  let teamLink = null
  if(!isWebView) {
    teamLink = (
      <a href={team.href}>
        <span className="long-name">{team.abbrev ? team.abbrev : team.name}</span>
        <abbr>{team.abbrev}</abbr>
      </a>
    )
  } else{
    teamLink = (
      <a data-linktype="clubhouse" className="app_partial" data-uid={team.uid}>
        <span className="long-name">{team.abbrev ? team.abbrev : team.name}</span>
        <abbr>{team.abbrev}</abbr>
      </a>
    )
  }
  return teamLink
}

const TeamLogo = ({
  team = {},
  isWebView = false
}) => {
  let teamLogo = null
  if(!isWebView) {
    teamLogo = (
      <a href={team.href}>
        <img data-src={team.logo} className="lazyload"/>
      </a>
    )
  } else{
    teamLogo = (
      <a data-linktype="clubhouse" className="app_partial" data-uid={team.uid}>
        <img data-src={team.logo} className="lazyload"/>
      </a>
    )
  }
  return teamLogo
}

const CricketRow = ({
  home = {},
  away = {},
  result = '',
  date = '',
  leagueName = '',
  url = '#',
  isWebView = false
}) => {

  return (
    <tr className="">
      <td>
        <TeamLink key="thl-a" isWebView={isWebView} team={home} />
      </td>
      <td className="logo">
      {
        home.logo && 
        <TeamLogo key="thl-b" isWebView={isWebView} team={home} />
      }
      </td>
      <td>
      {
        home.score &&
        <a href={url} dangerouslySetInnerHTML={{ __html: home.score }} ></a>
      }
      </td>
      <td className="outcome">
      {
        result &&
        <a href={url}>{result}</a>
      }
      </td>
      <td className="align-right">
      {
        away.score &&
        <a href={url} dangerouslySetInnerHTML={{ __html: away.score }} ></a>
      }
      </td>
      <td className="logo">
      {
        away.logo && 
        <TeamLogo key="thl-c" isWebView={isWebView} team={away} />
      }
      </td>
      <td>
        <TeamLink key="thl-d" isWebView={isWebView} team={away} />
      </td>
      <td>{date}</td>
      <td className="competition wrap">
        <span>{leagueName}</span>
      </td>
    </tr>
  )
}

export const HeadToHead = ({
  sport = '',
  keys = [],
  games = [],
  isWebView = false
}) => {

  const head2Head = (
    <div className={classnames('sub-module last-games head-to-head', sport)}>
      <header className="bordered">
        <h1>Head To Head</h1>
      </header>
      <div className="content" style={{ overflowX : 'auto' }}>
        <table data-fix-cols="0">
          <thead>
            <tr>
            {
              keys.map((k, i) => {
                return <th key={i} colSpan={k.colSpan || ''}>{k.title}</th>
              })
            }
            </tr>
          </thead>
          <tbody>
            {
              games.map((g, i) => {
                // TODO: select row based on sport
                return <CricketRow key={i} {...g} isWebView={isWebView} />
              })
            }
          </tbody>
        </table>
      </div>
    </div>

  )

  return games.length ? head2Head : <div/>
}

export default HeadToHead



// WEBPACK FOOTER //
// ../app/components/gamepackage/HeadToHead.jsx